import { IFinalResponse, MetadataTypes } from '_core/types';

export const getReturnResponseDefault = (
  metadata: MetadataTypes,
): IFinalResponse => {
  return {
    errors: {
      flow: {},
      infos: {},
      details: [],
    },
    success: false,
    data: {},
    metadata,
  };
};
